import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import _ from "lodash";
import moment from "moment-timezone";

import { DormitoryTab } from "components/pages/dormitories-page";
import { Container, Row } from "components/ui-kit/styled-templates";
import Table from "components/ui-kit/table";

import { EVENT_TYPES_OPTIONS } from "constants/config";

import LabsApi from "api/labs-api";
import UniversityApi from "api/university-api";

import useBodyBackground from "hooks/useBodyBackground";
import useQueryParams from "hooks/useQueryParams";
import { useStorageListener } from "hooks/useStorage";

const LabsListPage = () => {
    const { t } = useTranslation();

    const { params } = useQueryParams();
    const { universityId } = params;
    const navigate = useNavigate();
    useBodyBackground("white");

    const university = useStorageListener(`universities`, {});
    const labs = useStorageListener(`labs`, []);

    const selectedUniversity = _.get(university, universityId);

    const rows = _.values(labs)?.filter?.((i) => (!!universityId ? i?.universityId === universityId : true));

    useEffect(() => {
        UniversityApi.getAllUniversitiesData();
        LabsApi.getLabs();
    }, []);

    const rowsToShow = rows.map((i) => ({ ...i, university: _.get(university, i.universityId) }));

    return (
        <Container extra="padding-top: 10px; align-items: flex-start;">
            <Row extra="gap: 15px;">
                {universityId && (
                    <DormitoryTab.Link color="blue" direction="left" onClick={() => navigate(-1)}>
                        {t("036p26d5q6hk")}
                    </DormitoryTab.Link>
                )}
                <h2>{t("ugqwknen0xw")}</h2>
            </Row>
            {universityId && (
                <Row extra="gap: 10px;">
                    <strong>{t("8lad6jnl7up")}</strong>
                    <p>{_.get(selectedUniversity, `details.name`)}</p>
                </Row>
            )}
            <Table
                name="admin-labs-dashboard"
                withPagination={false}
                useBackendProcessing={false}
                paginationPerPage={2000}
                rows={rowsToShow}
                sortable={true}
                columns={[
                    { name: `number`, label: `№`, extra: `width: 50px; flex: unset;`, showIndexOnClick: true },
                    { name: `details.name`, label: `Название` },
                    { name: `university.details.shortName`, label: `Университет` },
                    { name: `details.city`, label: `Город` },
                    { name: `details.phone`, label: `Телефон` },
                    {
                        name: `onModeration`,
                        label: `Ожидает модерации`,
                        transform: ({ row }) => (row?.onModeration ? t("igs9x5cjcfr") : t("iv9r5j6zkco")),
                    },
                    {
                        name: `hideFromAll`,
                        label: ``,
                        transform: ({ row }) => (row?.hideFromAll ? 'y-y' : '-'),
                        cell: {
                            type: "icon",
                            className: "w-6 h-6 cursor-pointer",
                            srcFunction:  (({ row }) => (row?.hideFromAll ? 'eye-x' : ''))
                        }
                    },
                    {
                        name: `menu`,
                        label: ``,
                        sortable: false,
                        extra: `flex: unset; width: 24px;`,
                        cell: {
                            type: `menu`,
                            options: [
                                { label: `Просмотр`, onClick: ({ row, navigate }) => navigate(`/lab/${row.id}`) },
                                {
                                    label: `Модерация пройдена`,
                                    onClick: ({ row, navigate }) =>
                                        LabsApi.updateLab({ id: row.id, universityId: row.universityId, onModeration: false }),
                                },
                                {
                                    label: `Вернуть на модерацию`,
                                    onClick: ({ row, navigate }) =>
                                        LabsApi.updateLab({ id: row.id, universityId: row.universityId, onModeration: true }),
                                },
                            ],
                        },
                    },
                ]}
            />
        </Container>
    );
};

export default LabsListPage;
